import React from 'react';
import {ScrollView, Text as RNText} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';
import {chestnut} from '/theme/color/secondary.color';

storiesOf('base', module).add('Text', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Text</Heading>
        <Spacer size={24} />
        <Heading level={2}>Text Variants</Heading>
        <Spacer size={16} />
        <RNText>
          By default, rendering a <Code>{'<Text />'}</Code> component will
          render the body variant with high emphasis color. Alternatively, the
          body text or any other variant can be rendered by setting{' '}
          <Code>{'variant="body"'}</Code>.
        </RNText>
        <Spacer size={24} />
        <Text variant="xLarge">Display XLarge</Text>
        <Spacer size={16} />
        <Text variant="large">Display Large</Text>
        <Spacer size={16} />
        <Text variant="medium">Display Medium</Text>
        <Spacer size={16} />
        <Text variant="small">Display Small</Text>
        <Spacer size={16} />
        <Text variant="heading">Heading</Text>
        <Spacer size={16} />
        <Text variant="subheading">Subheading</Text>
        <Spacer size={16} />
        <Text variant="body">Body</Text>
        <Spacer size={16} />
        <Text variant="button">Button</Text>
        <Spacer size={16} />
        <Text variant="caption">Caption</Text>
        <Spacer size={16} />
        <Text variant="label">Label</Text>
        <Spacer size={24} />
        <Heading level={2}>Text Color</Heading>
        <Spacer size={16} />
        <RNText>
          The color of the <Code>{'<Text />'}</Code> component can be controlled
          in three different ways. The first is choosing by an{' '}
          <Code>{'emphasis="high"'}</Code>, which controls the dark text colors.
          The second is by setting <Code>{'useCompetency={true}'}</Code>, which
          will render the text color according to the current user's competency
          level. The third is to override{' '}
          <Code>{'style={{color: "#454F5B"}}'}</Code>.
        </RNText>
        <Spacer size={16} />
        <Text emphasis="medium">Medium emphasis text</Text>
        <Spacer size={6} />
        <Code>{'emphasis="medium"'}</Code>
        <Spacer size={16} />
        <Text emphasis="dull">Dull emphasis text</Text>
        <Spacer size={6} />
        <Code>{'emphasis="dull"'}</Code>
        <Spacer size={16} />
        <Text useCompetency={true}>Competency-controlled text</Text>
        <Spacer size={6} />
        <Code>{'useCompetency={true}'}</Code>
        <Spacer size={16} />
        <Text style={{color: chestnut}}>Error text</Text>
        <Spacer size={6} />
        <Code>{'style={{color: chestnut}}'}</Code>
        <Spacer size={24} />
        <Heading level={2}>Truncate Value</Heading>
        <Spacer size={16} />
        <RNText>
          <Code>truncateValue</Code> prop makes component truncate double digits
          by using <Code>toInteger()</Code> by lodash. Make sure to not pass
          values that can't be properly truncated.
        </RNText>
        <Spacer size={16} />
        <Code>{'<Text truncateValue>22.67</Text>'}</Code>
        <Spacer size={6} />
        <Text truncateValue>22.67</Text>
        <Spacer size={16} />
        <Code>{'<Text truncateValue>Hi Hello</Text>'}</Code>
        <Spacer size={6} />
        <Text truncateValue>Hi</Text>
        <Spacer size={24} />
        <Heading level={2}>isBold</Heading>
        <RNText>
          <Code>isBold</Code> prop handles the fontWeight on both platforms ios
          and Android. If you want to specify only the fontweight and handle the
          fontSize seperately in your style object, it's best to use this prop.
        </RNText>
        <Spacer size={16} />
        <Code>{'<Text isBold>I want to be bold!</Text>'}</Code>
        <Spacer size={6} />
        <Text isBold>I want to be bold!</Text>
      </FlexView>
    </Spacing>
  </ScrollView>
));
